import React from "react";
import styled from "styled-components";
import { Centered } from "../containers/Layout";

const Headline = styled.div`
  font-family: "Raleway", sans-serif;
  font-size: 2.5em;
  color: #333333;
  font-weight: normal;
  text-align: center;
  padding: 0 1em 0 1em;
`;

export default ({ children }) => <Headline children={children} />;



// WEBPACK FOOTER //
// /opt/build/repo/src/segments/HeadlineSegment.js